import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {  Add } from "@mui/icons-material";
import { Container, Grid, Modal, Typography } from "@mui/material";
import EmailTable from "./emailsTable";
import { useEffect, useState } from "react";
import ButtonsOptions from "./buttonsOptions";
import { api } from "../../services/api"


export default function Emails() {
    const [emails, setEmails] = useState([]);
    const [deletedEmail, setDeletedEmail] = useState({
        email: "",
        flags: []
    })
    const [deleteAlert, setDeleteAlert] = useState(false)
    useEffect(() => {
        api.getEmails().then(data => {
            setEmails(data)
            console.log(data)
        })
    }, [])

    const handleDelete = () => {
        api.deleteEmail(deletedEmail).then(() => {
            setEmails((emailPrev) => {
                return emailPrev.filter((email, index) => {
                    return email.email != deletedEmail.email
                })
            })
        })
        setDeleteAlert(false)
    }

    return (
        <Container maxWidth="xg" sx={{ mt: 4, mb: 4 }}>
            <Modal onClose={() => setDeleteAlert(false)} open={deleteAlert} >
                <Box sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    ml: 2,
                    mr: 2,
                    mb: 0,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    pt: 2,
                    px: 4,
                    pb: 3,
                }}>
                    <Typography variant="h6" component="h2">
                        Apagar o email {deletedEmail.email}?
                    </Typography>
                    <Button color='error' onClick={() => handleDelete()}>Apagar</Button>
                    <Button onClick={() => setDeleteAlert(false)}>Cancelar</Button>
                </Box>
            </Modal>
            <Grid item xs={12}>
                <ButtonsOptions />
            </Grid>
            <Grid item xs={12}>
                <EmailTable 
                    rows={emails}
                    onEdit={(emailEdited) => {
                        return api.putEmail(emailEdited)
                    }}
                    onDelete={(emailDel) => {
                        setDeleteAlert(true)
                        setDeletedEmail(emailDel)
                    }}
                    onCreate={(emailCreated) => {
                        api.postEmails([emailCreated]).then(() => {
                            setEmails((emailsPrev) => {
                                emailsPrev.pop()
                                return [...emailsPrev, emailCreated]

                            })
                        })
                    }}
                    onCancel={() => {
                        setEmails((emailsPrev) => {
                            emailsPrev.pop()
                            return [...emailsPrev]

                        })
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ m: 1 }}>
                    <Button
                        startIcon={(<Add />)}
                        color="primary"
                        variant="contained"
                        size="small"
                        disableElevation
                        onClick={() => {
                            setEmails((emailsPrev) => {
                                if(emailsPrev.length === 0){
                                    return [
                                        {
                                            email: "",
                                            flags: []
                                        }
                                    ]
                                }
                                if(emailsPrev.at(-1).email === ""){
                                    return emailsPrev
                                }
                                console.log([...emailsPrev, {
                                    email: "",
                                    flags: []
                                }])
                                return [...emailsPrev, {
                                    email: "",
                                    flags: []
                                }]
                            })
                        }}
                        >
                        Adicionar
                    </Button>
                </Box>
            </Grid>
        </Container>
    )
}